import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Datagrid from "../Components/Datagrid";
import UnauthorizePage from "./UnauthorizePage";
import ForbiddenPage from "./ForbiddenPage";
import DatagridContext from "../Context/datagridContext";
import toolbar from "../Config/toolbarConfig";
import useTitle from "../Hooks/useTitle";
import { useTranslation } from "react-i18next";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";
const MessageDetailsPage = () => {
  const { envelopeId } = useParams();

  const [url, setUrl] = useState("");
  const [from, setFrom] = useState("");
  const [status, setStatus] = useState(null);

  const { t } = useTranslation();

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useTitle(`${t("Message Details")} | Netileti`);

  useEffect(() => {
    const fetchUserTransactions = async () => {
      setUrl(`${baseUrl}/webhook/Conversations/${envelopeId}`);
      setFrom("MessageDetails");
    };

    fetchUserTransactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatPhoneNumber = (value) => {
    if (!value) return '';
    const numericValue = value.replace(/[^0-9]/g, '');
    if (numericValue.length !== 12) return value;
    
    return `+${numericValue.slice(0, 2)} (${numericValue.slice(2, 5)})-${numericValue.slice(5, 8)}-${numericValue.slice(8)}`;
  };

  const columns = [
    {
      field: "envelopeId",
      headerText: "envelopeId",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "timestamp",
      headerText: t("Time"),
      allowEditing: false,
      template: ({ timestamp }) =>
        timestamp ? timestamp : t("MessageStatuses.no status.label"),
    },
    {
      field: "receipentPhoneNr",
      headerText: t("Receipent"),
      allowEditing: false,
      template: ({ receipentPhoneNr }) => {
        const phoneRegex = /\(\(.*?\)\)/;
        const match = receipentPhoneNr.match(phoneRegex);
        const phoneNumber = match
          ? match[0].replace(/\(\(|\)\)/g, "").trim()
          : "";
        const name = receipentPhoneNr.replace(phoneRegex, "").trim();

        return (
          <div>
            <TooltipComponent content={formatPhoneNumber(phoneNumber)}>
              <div style={{ fontSize: "16px" }}>{name}</div>
            </TooltipComponent>
          </div>
        );
      },
    },
    {
      field: "status",
      headerText: t("Status"),
      allowEditing: false,
      width: "10%",
      textAlign: "Center",
      template: ({ status }) => (
        <TooltipComponent content={t(`MessageStatuses.${status}.label`)}>
          <span
            className={t(`MessageStatuses.${status}.icon`)}
            style={{ color: t(`MessageStatuses.${status}.color`) }}
          />
        </TooltipComponent>
      ),
      filterTemplate: () => (
        <ComboBoxComponent
          dataSource={[
            { text: t("MessageStatuses.read.label"), value: "read" },
            { text: t("MessageStatuses.delivered.label"), value: "delivered" },
            { text: t("MessageStatuses.sent.label"), value: "sent" },
            { text: t("MessageStatuses.no status.label"), value: "no status" },
            { text: t("MessageStatuses.error.label"), value: "error" },
          ]}
          fields={{ text: "text", value: "value" }}
          change={(e) => {
            const selectedValue = e.value;
            const gridElement = document.getElementById("adaptivebrowser");
            if (gridElement) {
              const grid = gridElement.ej2_instances[0];

              if (grid) {
                if (selectedValue) {
                  // Filtreyi uygula
                  grid.filterByColumn("status", "equal", selectedValue);
                } else {
                  // Filtreyi temizle
                  grid.removeFilteredColsByField("status");
                }
              }
            }
          }}
        />
      ),
    },
    {
      field: "errorCode",
      headerText: t("Error Code"),
      allowEditing: false,
    },
    {
      field: "errorMessage",
      headerText: t("Error Message"),
      allowEditing: false,
    },
  ];
  
  if (!url) {
    return <div></div>;
  }
  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center", height: "auto" }}
    >
      {status === 401 ? (
        <UnauthorizePage />
      ) : status === 403 ? (
        <ForbiddenPage />
      ) : (
        <DatagridContext.Provider
          value={{
            url,
            toolbar: toolbar("EXPORT"),
            setStatus,
            from,
          }}
        >
          <Datagrid columns={columns} />
        </DatagridContext.Provider>
      )}
    </div>
  );
};

export default MessageDetailsPage;
